import { useQuery } from '@apollo/client';
import { graphql } from '../gql';
import { ContentTargetAreaType, InputMaybe } from '../gql/graphql';

export const GET_CONTENTS = graphql(`
  query getContents(
    $targetUuid: String
    $targetArea: ContentTargetAreaType
    $label: String
  ) {
    content(
      filters: {
        targetUuid: $targetUuid
        targetArea: $targetArea
        label: $label
      }
    ) {
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          uuid
          label
          targetUuid
          targetType
          targetName
          content
        }
      }
    }
  }
`);
export interface IUseContentQueryArg {
  targetUuid?: string | null;
  targetArea?: InputMaybe<ContentTargetAreaType>;
  label?: string | null;
}
export function useContentQuery({
  targetUuid,
  targetArea,
  label,
}: IUseContentQueryArg) {
  const { loading, data, error } = useQuery(GET_CONTENTS, {
    variables: {
      targetUuid: targetUuid,
      targetArea: targetArea,
      label: label,
    },
  });

  return {
    loading,
    error,
    data,
  };
}
